import {useGlp1Modality} from 'surveys/osa_funnel/hooks/useGlp1Modality';
import {Glp1EducationIntroBranded} from './Glp1EducationIntroBranded';
import {Glp1EducationIntroCompounded} from './Glp1EducationIntroCompounded';

/** Step 8 dispatcher — picks branded vs compounded based on the
 *  `web_glp1_modality` GrowthBook flag (via useGlp1Modality). */
export const Glp1EducationIntro = () => {
  const modality = useGlp1Modality();
  return modality === 'compounded_v1' ? <Glp1EducationIntroCompounded /> : <Glp1EducationIntroBranded />;
};

export default Glp1EducationIntro;
